import React, { useCallback, useEffect, useState } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import LocationPicker from './LocationPicker'; 
import { setLocation } from '../../store/slices/LocationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducers';
import { getAddressFromLatLng } from '../getAddressFromLatLng';

const LocationComponent: React.FC = () => {
  const dispatch = useDispatch();
  const location = useSelector((state: RootState) => state.location.location);
  const [status, setStatus] = useState('Checking...');
  const [error, setError] = useState<string | null>(null);

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '', // Replace this
    libraries: ['places'],
  });

  const fetchLocation = () => {
    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser.');
      setStatus('Failed');
      window.dispatchEvent(
        new CustomEvent('app-toast', {
          detail: {
            message: 'Geolocation is not supported by your browser. Please search for a location manually.',
            type: 'error',
            duration: 5000,
          },
        }),
      );
      return;
    }

    setStatus('Requesting location...');

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        console.log('position', position);
        const LAT = position.coords.latitude;
        const LONG = position.coords.longitude;
        const address = await getAddressFromLatLng(LAT, LONG)
        dispatch(setLocation({
          lat: LAT,
          lng: LONG,
          name: address,
        }));
        
        setStatus('Success ✅');
        setError(null);
      },
      (err) => {
        setStatus('Failed ❌');
        setError(err.message);
        
        // Show toast notification with specific error message
        let errorMessage = 'Unable to get your location. Please check your browser settings.';
        let errorType: 'error' | 'warning' = 'error';
        
        switch (err.code) {
          case err.PERMISSION_DENIED:
            errorMessage = 'Location access denied. Please enable location permissions in your browser settings.';
            errorType = 'warning';
            break;
          case err.POSITION_UNAVAILABLE:
            errorMessage = 'Location information is unavailable. Please try again or search for a location manually.';
            break;
          case err.TIMEOUT:
            errorMessage = 'Location request timed out. Please try again.';
            break;
          default:
            errorMessage = 'Unable to get your location. Please check your browser settings or search for a location manually.';
            break;
        }
        
        window.dispatchEvent(
          new CustomEvent('app-toast', {
            detail: {
              message: errorMessage,
              type: errorType,
              duration: 5000,
              onClick: () => {
                if (err.code === err.PERMISSION_DENIED) {
                  window.open('https://support.google.com/chrome/answer/114662', '_blank');
                }
              },
            },
          }),
        );
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  };

  useEffect(() => {
    fetchLocation();
  }, []);

  if (loadError) return <p>Error loading Google Maps</p>;
  if (!isLoaded) return <p>Loading Map...</p>;

  return (
    null
    // <div style={{ padding: 20 }}>
    //   <h2>Location Access</h2>
    //   <p>Status: {status}</p>
    //   {error && <p style={{ color: 'red' }}>Error: {error}</p>}
    //   {location?.lat && location?.lng && (
    //     <p>
    //       📍 Latitude: {location.lat} <br />
    //       📍 Longitude: {location.lng}
    //     </p>
    //   )}
    //   <button onClick={fetchLocation} style={{ marginTop: 10 }}>
    //     Try Again
    //   </button>

    //   <hr style={{ margin: '20px 0' }} />

    //   <LocationPicker />
    // </div>
  );
};

export default LocationComponent;




// const containerStyle = {
//   width: '100%',
//   height: '400px',
// };

// const center = {
//   lat: 20.5937,
//   lng: 78.9629,
// };

// const LocationPicker: React.FC = () => {
//   const [selectedLocation, setSelectedLocation] = useState<{ lat: number; lng: number } | null>(null);
//   const [address, setAddress] = useState<string | null>(null);

//   const getAddressFromLatLng = (lat: number, lng: number) => {
//     const geocoder = new window.google.maps.Geocoder();
//     const latlng = { lat, lng };

//     geocoder.geocode({ location: latlng }, (results, status) => {
//       if (status === 'OK' && results && results.length > 0) {
//         setAddress(results[0].formatted_address);
//       } else {
//         setAddress('No address found');
//       }
//     });
//   };

//   const handleMapClick = useCallback((e: google.maps.MapMouseEvent) => {
//     if (e.latLng) {
//       const lat = e.latLng.lat();
//       const lng = e.latLng.lng();
//       setSelectedLocation({ lat, lng });
//       getAddressFromLatLng(lat, lng);
//     }
//   }, []);

//   return (
//     <div>
//       <h3>Pick a Location</h3>
//       <GoogleMap
//         mapContainerStyle={containerStyle}
//         center={selectedLocation || center}
//         zoom={selectedLocation ? 15 : 5}
//         onClick={handleMapClick}
//       >
//         {selectedLocation && <Marker position={selectedLocation} />}
//       </GoogleMap>

//       {selectedLocation && (
//         <div style={{ marginTop: '1rem' }}>
//           <strong>Selected Location:</strong>
//           <p>Latitude: {selectedLocation.lat}</p>
//           <p>Longitude: {selectedLocation.lng}</p>
//           <p><strong>Address:</strong> {address || 'Loading address...'}</p>
//         </div>
//       )}
//     </div>
//   );
// };


